import { ActionContext, Module } from 'vuex'
import { RootState } from '@/store'
import { SpermInsightsResponse, InsightsMetric } from '../types/insightsTypes'
import axios from 'axios'
import { errorSummary, RemoteLog } from '@/modules/common/utils/loggingUtils'

type Context = ActionContext<State, RootState>

export type State = {
	insightsData: SpermInsightsResponse | null
	loading: boolean
	selectedMetric: InsightsMetric
}

const state: State = {
	insightsData: null,
	loading: false,
	selectedMetric: 'sperm_score',
}

const mutations = {
	SET_INSIGHTS_DATA(state: State, data: SpermInsightsResponse) {
		state.insightsData = data
	},
	SET_LOADING(state: State, loading: boolean) {
		state.loading = loading
	},
	SET_SELECTED_METRIC(state: State, metric: InsightsMetric) {
		state.selectedMetric = metric
	},
}

const actions = {
	async fetchInsights({ commit }: Context) {
		commit('SET_LOADING', true)
		try {
			const response = await axios.get<SpermInsightsResponse>('/sperm-insights')
			commit('SET_INSIGHTS_DATA', response)
		} catch (error: any) {
			if (!error.handled) {
				RemoteLog.error({ message: 'Sperm insights failed to load', context: errorSummary(error) })
			}
		} finally {
			commit('SET_LOADING', false)
		}
	},
	setSelectedMetric({ commit }: Context, metric: InsightsMetric) {
		commit('SET_SELECTED_METRIC', metric)
	},
}

const getters = {
	insightsData: (state: State) => state.insightsData,
	loading: (state: State) => state.loading,
	selectedMetric: (state: State) => state.selectedMetric,
	hasAccess: (state: State) => state.insightsData?.has_access ?? false,
	hasData: (state: State) => state.insightsData?.has_data ?? false,
	hasSemenAnalysis: (state: State) => state.insightsData?.has_semen_analysis ?? false,
}

const module: Module<State, RootState> = {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}

export default module
